var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"extra-component-chartist-demo"}},[_c('div',{staticClass:"p-3 pt-2"},[_c('div',{staticClass:"mb-4 userStats p-5"},[_c('vs-row',{attrs:{"vs-justify":"space-between"}},[_c('div',{staticClass:"m-4 fontS20 ml-6 pl-1"},[_vm._v("Total Users")]),_c('div',{staticClass:"m-4 fontS20 mr-6 pr-4"},[_vm._v("\n          "+_vm._s(_vm.details.startM +
            " " +
            _vm.details.startY +
            " - " +
            _vm.details.endM +
            " " +
            _vm.details.endY)+"\n        ")])]),_c('div',[(_vm.key)?_c('vue-apex-charts',{attrs:{"type":"area","height":"350","width":"99%","options":_vm.chart.chartOptions,"series":_vm.chart.series}}):_vm._e()],1)],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }